import React, { useEffect, useState } from 'react';

/**
 * PinterestFormatlari: Pin, Fikir Pini, Pano ve Kolaj'ın ne olduğunu Pinterest'in
 * kendi arayüzünden alınmış ekran görüntüleriyle anlatan eğitim belgesi.
 * Route: /r/pinterest-formatlari (sidebar YOK, tam ekran belge)
 *
 * Marka verisi içermiyor — herhangi bir markaya kilitli değil, giriş yapmış
 * herkes açabilir (`requireBrand={false}`).
 *
 * İçerik statik. Ekran görüntüleri belgeye gömülü DEĞİL; hepsi
 * api.glowytics.com/pixel/pinterest/ altında duruyor (backend public/pinterest/).
 * Yeni görsel eklerken oraya koy ve mutlak api. adresiyle çağır — platform.
 * üzerinden verilen nested görselleri frontend proxy'si 502'ye düşürüyor.
 *
 * 🔑 Belgenin içindeki "PDF olarak kaydet" düğmesi iframe'in kendi belgesinde
 * `window.print()` çağırır — tarayıcı yalnızca belgeyi basar, dashboard'u değil.
 * Dış sayfadan Ctrl+P ise iframe'i tek sayfaya kırpar, o yüzden düğme belgenin
 * İÇİNDE duruyor; kaldırma.
 */
export default function PinterestFormatlari() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./pinterestFormatlariHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#0B1020">Belge yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini belgenin kendi zeminiyle aynı (--ground açık tema) — beyaz/siyah flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F5F6FA' }} />;

  return (
    <iframe
      title="Pinterest'in Dört Yapı Taşı · Pin, Fikir Pini, Pano, Kolaj"
      srcDoc={html}
      style={fill}
    />
  );
}
